const EmptyState = ({ title, description, icon = '📭' }) => (
  <div style={{ padding: 40, textAlign: 'center' }}>
    <div style={{ fontSize: 46, marginBottom: 10 }}>{icon}</div>
    <h3 style={{ fontSize: 17, color: '#0f172a', marginBottom: 6 }}>{title}</h3>
    <p style={{ fontSize: 13, color: '#64748b' }}>{description}</p>
  </div>
);

export default EmptyState;